import { Routes, Route } from "react-router-dom";
import { Layout } from "./layout/Layout";
import { Home } from "./pages/Home";
import { Platform } from "./pages/Platform";
import { Features } from "./pages/Features";
import { Pricing } from "./pages/Pricing";
import { Customers } from "./pages/Customers";
import { About } from "./pages/About";
import { Contact } from "./pages/Contact";
import { Demo } from "./pages/Demo";
import { Careers } from "./pages/Careers";
import { Press } from "./pages/Press";
import { Sitemap } from "./pages/Sitemap";
import { NotFound } from "./pages/NotFound";
import { Resources } from "./pages/Resources";
import { Blog } from "./pages/Blog";
import { BlogPost } from "./pages/BlogPost";
import { Docs } from "./pages/Docs";
import { SnfSolution } from "./pages/solutions/Snf";
import { AscSolution } from "./pages/solutions/Asc";
import { DialysisSolution } from "./pages/solutions/Dialysis";
import { Trust } from "./pages/trust/Trust";
import { Security } from "./pages/trust/Security";
import { Hipaa } from "./pages/trust/Hipaa";
import { Privacy } from "./pages/trust/Privacy";
import { Terms } from "./pages/trust/Terms";
import { Cookies } from "./pages/trust/Cookies";
import { Dpa } from "./pages/trust/Dpa";
import { Baa } from "./pages/trust/Baa";
import { Sla } from "./pages/trust/Sla";
import { Aup } from "./pages/trust/Aup";
import { Subprocessors } from "./pages/trust/Subprocessors";
import { Accessibility } from "./pages/trust/Accessibility";
import { Gdpr } from "./pages/trust/Gdpr";
import { Ccpa } from "./pages/trust/Ccpa";
import { Status } from "./pages/trust/Status";
import { ResponsibleDisclosure } from "./pages/trust/ResponsibleDisclosure";
import { SmsTerms } from "./pages/trust/SmsTerms";
import { AspMethodologyPage } from "./pages/trust/AspMethodologyPage";
import { DdiMethodologyPage } from "./pages/trust/DdiMethodologyPage";
import { MedCartInspectionMethodologyPage } from "./pages/trust/MedCartInspectionMethodologyPage";
import { NarcoticDestructionMethodologyPage } from "./pages/trust/NarcoticDestructionMethodologyPage";
import { PlatformAiBubbleMethodology } from "./pages/trust/PlatformAiBubbleMethodology";
import { ClinicalToolkitMethodology } from "./pages/trust/ClinicalToolkitMethodology";
import { RegulatoryHorizonMethodology } from "./pages/trust/RegulatoryHorizonMethodology";
import { LicensingMethodology } from "./pages/trust/LicensingMethodology";
import { HelpAiMethodology } from "./pages/trust/HelpAiMethodology";
import { RegulatoryAiMethodology } from "./pages/trust/RegulatoryAiMethodology";

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/platform" element={<Platform />} />
        <Route path="/features" element={<Features />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/demo" element={<Demo />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/press" element={<Press />} />
        <Route path="/sitemap" element={<Sitemap />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/docs" element={<Docs />} />
        <Route path="/solutions/snf" element={<SnfSolution />} />
        <Route path="/solutions/asc" element={<AscSolution />} />
        <Route path="/solutions/dialysis" element={<DialysisSolution />} />
        <Route path="/trust" element={<Trust />} />
        <Route path="/security" element={<Security />} />
        <Route path="/hipaa" element={<Hipaa />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/cookies" element={<Cookies />} />
        <Route path="/dpa" element={<Dpa />} />
        <Route path="/baa" element={<Baa />} />
        <Route path="/sla" element={<Sla />} />
        <Route path="/aup" element={<Aup />} />
        <Route path="/subprocessors" element={<Subprocessors />} />
        <Route path="/accessibility" element={<Accessibility />} />
        <Route path="/gdpr" element={<Gdpr />} />
        <Route path="/ccpa" element={<Ccpa />} />
        <Route path="/status" element={<Status />} />
        <Route path="/responsible-disclosure" element={<ResponsibleDisclosure />} />
        <Route path="/sms-terms" element={<SmsTerms />} />
        <Route path="/trust/asp-methodology" element={<AspMethodologyPage />} />
        <Route path="/trust/ddi-methodology" element={<DdiMethodologyPage />} />
        <Route
          path="/trust/med-cart-inspection-methodology"
          element={<MedCartInspectionMethodologyPage />}
        />
        <Route
          path="/trust/narcotic-destruction-compliance"
          element={<NarcoticDestructionMethodologyPage />}
        />
        <Route
          path="/trust/platform-ai-bubble-methodology"
          element={<PlatformAiBubbleMethodology />}
        />
        <Route path="/trust/clinical-toolkit-methodology" element={<ClinicalToolkitMethodology />} />
        <Route
          path="/trust/regulatory-horizon-methodology"
          element={<RegulatoryHorizonMethodology />}
        />
        <Route path="/trust/licensing-methodology" element={<LicensingMethodology />} />
        <Route path="/trust/help-ai-methodology" element={<HelpAiMethodology />} />
        <Route path="/trust/regulatory-ai-methodology" element={<RegulatoryAiMethodology />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
